import { SxStyleProp } from "theme-ui"

export const root: SxStyleProp = {
  display: "grid",
  gridTemplateColumns:
    "26px 68px 4fr min-content 2fr 2fr min-content min-content",
  alignItems: "baseline",
  gridColumnGap: 12,
}

export const incidentBadge: SxStyleProp = {
  position: "relative",
  top: "-2px",
}

export const roleName: SxStyleProp = {
  color: "primary",
}

export const severity: SxStyleProp = {
  mb: 2,
}

export const slackButton: SxStyleProp = {
  visibility: "hidden",
  position: "relative",
  top: 2,

  "tr:hover &": {
    visibility: "visible",
  },
}
